import apiService from '@/services/api.service';
import ApiService from '@/services/api.service';
import { onMounted, onUnmounted, ref } from 'vue';
import { removeNullProperties } from '@/composable/removeNullProperties';

const hasUnreadMsg = ref(true);
const isNotifyLoading = ref(false);
const hasNotification = ref(false);

const notificationList = ref();
const notifyUnreadCount = ref();

export default function useNotifications() {
  async function fetchNotification(queries = { per_page: 5 }) {
    isNotifyLoading.value = true;
    let payload = removeNullProperties(queries);

    let path = '/notification?' + new URLSearchParams(payload);

    return ApiService.get(path)
      .then((response) => {
        notificationList.value = response.data;
        notifyUnreadCount.value = response?.data?.meta?.unread_count;
      })
      .catch((error) => {
        throw new Error(error);
      })
      .finally(() => {
        isNotifyLoading.value = false;
      });
  }

  async function fetchIfNotificationExist(hasNeedForceFetchNoty) {
    let path = '/notification/has-unread';

    return ApiService.get(path)
      .then((response) => {
        hasUnreadMsg.value = response.data.has_unread;
        if (hasNeedForceFetchNoty) {
          fetchNotification();
        }
      })
      .catch((error) => {
        throw new Error(error);
      });
  }

  async function handleReadMsg(id, isReaded = false, isNeedToReFetchData = true) {
    let payload = {};
    if (id) {
      payload.id = id;
    }
    let path = '/notification/' + (isReaded ? 'mark-as-unread' : 'mark-as-read');
    return apiService.patch(path, payload).then(() => {
      fetchIfNotificationExist(isNeedToReFetchData);
    });
  }

  async function handleDeleteAllNotify() {
    let path = '/notification/delete-all';
    return apiService.delete(path).then(() => {
      fetchIfNotificationExist(true);
    });
  }

  return {
    handleDeleteAllNotify,
    hasNotification,
    isNotifyLoading,
    handleReadMsg,
    fetchIfNotificationExist,
    notificationList,
    fetchNotification,
    notifyUnreadCount,
    hasUnreadMsg
  };
}

export function usePolling(apiFunction, intervalTime = 120000) {
  // 2 minutes = 120,000 ms
  let intervalId = null;

  const startPolling = () => {
    if (intervalId) return; // Prevent multiple intervals
    intervalId = setInterval(async () => {
      if (!hasUnreadMsg.value) {
        try {
          await apiFunction();
        } catch (error) {
          stopPolling(); // Optional: Stop polling on error
        }
      }
    }, intervalTime);
  };

  const stopPolling = () => {
    if (intervalId) {
      clearInterval(intervalId);
      intervalId = null;
    }
  };

  onMounted(startPolling);
  onUnmounted(stopPolling);

  return {
    startPolling,
    stopPolling
  };
}
